import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { Grid, Row, Col } from 'react-flexbox-grid'

import Header from './Header'
import ReportsNPOLocationsView from '../../views/ReportsNPOLocations'

import './styles.scss'

export default class ReportsNPOLocations extends React.PureComponent {
  render() {
    return (
      <Grid>
        <Row>
          <Col xs={12}>
            <Header />
          </Col>
        </Row>
        <Switch>
          <Route component={ReportsNPOLocationsView} />
        </Switch>
      </Grid>
    )
  }
}
